import { render, staticRenderFns } from "./Fund-Tip-item.vue?vue&type=template&id=489d4bd7&scoped=true&"
import script from "./Fund-Tip-item.vue?vue&type=script&lang=js&"
export * from "./Fund-Tip-item.vue?vue&type=script&lang=js&"
import style0 from "./Fund-Tip-item.vue?vue&type=style&index=0&id=489d4bd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d4bd7",
  null
  
)

export default component.exports